import React from 'react'
import styled from '@emotion/styled'
import { Link } from 'react-router'
import { getHostHelpers } from '@mobi/betslip/helpers/hostHelpers'
import type { LinkInfo } from '../../../types'

export const LinkWrapper: React.FC<{
  children: React.ReactNode
  linkInfo?: LinkInfo
}> = ({ linkInfo, children }) => {
  const hostHelpers = getHostHelpers()

  const onLinkClick = () => {
    hostHelpers.toggleBetSlipDrawer?.(false)
    linkInfo?.handleNavigationTracking && linkInfo.handleNavigationTracking()
  }

  if (!linkInfo) return <span>{children}</span>

  return (
    <LinkStyled to={linkInfo.state ? linkInfo : linkInfo.pathname} onClick={onLinkClick}>
      {children}
    </LinkStyled>
  )
}

// ======
// Styles
// ======

const LinkStyled = styled(Link)({
  padding: 0,
  margin: 0,
  color: 'unset',
  textDecoration: 'unset',
  transition: 'opacity 300ms ease',
  WebkitTapHighlightColor: 'transparent',

  '@media (hover: hover)': {
    ':hover': { opacity: 0.6 },
  },
})
